<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <div style="margin-bottom: 15px;">
      <el-button type="success" @click="shuaixn">刷新</el-button>
    </div>

    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <!-- <el-form-item label="会员信息">
            <el-input v-model="searchForm.search" placeholder="请输入昵称|手机号|ID"></el-input>
          </el-form-item> -->
        <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no"
            placeholder="请输入订单号"></el-input></el-form-item>
        <el-form-item label="姓名"><el-input size="small" v-model="searchForm.user_name"
            placeholder="请输入姓名"></el-input></el-form-item>

        <el-form-item label="手机号"><el-input size="small" v-model="searchForm.mobile"
            placeholder="请输入手机号"></el-input></el-form-item>

        <el-form-item label="身份证"><el-input size="small" v-model="searchForm.usernum"
            placeholder="请输入身份证"></el-input></el-form-item>

        <el-form-item label="用户id"><el-input size="small" v-model="searchForm.user_id"
            placeholder="请输入用户id"></el-input></el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.create_time" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button size="small" type="primary" icon="el-icon-search"
            @click="onSubmit">查询</el-button></el-form-item>
        <!-- <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item> -->
      </el-form>
    </div>

    <div class="product-content">
      <template>
        <el-table :data="tabledata" border style="width: 100%" height="600">
          <!-- <el-table-column prop="id" label="id"> </el-table-column> -->
          <el-table-column prop="user_id" label="用户id">
          </el-table-column>
          <el-table-column prop="user_name" label="姓名"> </el-table-column>
          <el-table-column label="签署链接" width="280">
            <template slot-scope="scope">
              <!-- <div style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                {{ scope.row.user_url }}
              </div> -->
              <div style="display:flex;">
                <el-input type="input" autosize v-model="scope.row.user_url">
                </el-input>
                <div @click="dakai(scope.row.user_url)"
                  style="display:flex;justify-content: center;align-items: center;background: #E6E6E6;width: 30px;cursor:pointer;">
                  <i class="el-icon-share"></i>
                </div>

              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="打开链接" width="120">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <el-button type="info" @click="dakai(scope.row.user_url)">打开链接</el-button>
            </template>
          </el-table-column> -->
          <el-table-column label="流程状态">
            <template slot-scope="scope">
              <div v-if="scope.row.jieguo == '完成'" style="color: red;">
                {{ scope.row.jieguo }}
              </div>
              <div v-else style="color: #18C1C1;">
                {{ scope.row.jieguo }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="是否已经取消代扣" width="80">
            <template slot-scope="scope">
              {{ scope.row.cancel_withholding == 1 ? "已取消" : "-" }}
            </template>
          </el-table-column>
          <el-table-column label="取消原因">
            <template slot-scope="scope">
              {{ scope.row.cancel_withholding_content ? scope.row.cancel_withholding_content : "-" }}
            </template>
          </el-table-column>
          <el-table-column label="取消时间" width="140">
            <template slot-scope="scope">
              {{ scope.row.cancel_withholding_time != 0 ? scope.row.cancel_withholding_time : "-" }}
            </template>
          </el-table-column>
          <el-table-column prop="order_no" label="订单号" width="140"> </el-table-column>
          <el-table-column label="签署时间" width="140">
            <template slot-scope="scope">
              <div v-if="scope.row.signing_time != 0">
                {{ scope.row.signing_time | formatDate }}
              </div>
              <div v-else>
                -
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sign_id" label="发起签署id" width="100"> </el-table-column>
          <el-table-column prop="pdf_id" label="PDF_id" width="100"> </el-table-column>
          <el-table-column prop="withhold_user_id" label="代扣用户id" width="100">
          </el-table-column>
          <el-table-column prop="create_signature_id" label="创建签署id" width="100">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="anniu">
                <el-button @click="chaxun(scope.row)" type="info" size="small">查询</el-button>
              </div>
              <!-- <div class="anniu">
                <el-button @click="xiazai(scope.row)" type="primary" size="small">下载</el-button>
              </div> -->
              <div class="anniu">
                <el-button @click="godelete(scope.row)" type="danger" size="small">删除</el-button>
              </div>
              <div class="anniu">
                <el-button @click="quxiao(scope.row)" type="primary" size="small">取消代扣</el-button>
              </div>

              <el-dropdown split-button type="primary" @click="handleClick">
                下载合同
                <el-dropdown-menu slot="dropdown">
                  <div class="anniu">
                    <el-button @click="xiazai3(scope.row)" type="primary" size="small">下载主合同</el-button>
                  </div>
                  <div class="anniu">
                    <el-button @click="xiazai(scope.row)" type="primary" size="small">下载合同</el-button>
                  </div>
                  <div class="anniu">
                    <el-button @click="xiazai2(scope.row)" type="primary" size="small">下载合同</el-button>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>

            </template>
          </el-table-column>
        </el-table>
      </template>
      <!-- 弹窗 -->
      <el-dialog title="签署状态" :visible.sync="dialogTableVisible">
        <span class="qianshu">{{ xing }}</span>
      </el-dialog>
      <!-- 备注 -->
      <el-dialog title="取消代扣" :visible.sync="dialogTableVisible1" width="50%">
        <div class="qing">请仔细核对订单号</div>
        <div class="dingdan">
          订单id:{{ order_id }}
          <span>姓名：{{ user_name }}</span>
          <span>单号:{{ order_no }}</span>
        </div>
        <div class="daikou">
          确定取消代扣吗？请慎重考虑！！！代扣取消后不可撤销
        </div>
        <div class="daikou">用户申请过的才可以取消</div>
        <!-- <span>订单id:{{}};姓名：{{}};单号：{{}}</span> -->
        <div style="margin: 25px 0">
          <el-input v-model="tips" placeholder="取消原因"></el-input> <br />
        </div>
        <el-button @click="dialogTableVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="queding5()">确 定</el-button>
      </el-dialog>

        <!-- 删除 -->
        <el-dialog title="删除合同" :visible.sync="dialogTableVisible2" width="50%">
        <div class="qing">请仔细核对订单号</div>
        <div class="dingdan">
          订单id:{{ order_id }}
          <span>姓名：{{ user_name }}</span>
          <span>单号:{{ order_no }}</span>
        </div>
        <div class="daikou">
          必须先解除代扣协议,再删除合同
        </div>
        <el-button @click="dialogTableVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="queding6()">确 定</el-button>
      </el-dialog>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-sizes="[5, 10, 20, 50]" :page-size="10"
          layout="total, prev,sizes ,pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>
    <Logistics :logisticsData="logisticsData" :isLogistics="isLogistics">
    </Logistics>
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import { timeFormat } from "@/utils/timeFormat";
import FengkongApi from "@/api/fengkong.js";
import Logistics from "@/components/logistics/viewLogistics.vue";
import qs from "qs";
export default {
  name: "Login",
  components: {
    Logistics,
  },
  data() {
    return {
      /*横向表单数据模型*/
      searchForm: {
        user_id: "",
        user_name: "",
        usernum: "",
        mobile: "",
        search: "",
        order_no: "",
        style_id: "",
        create_time: "",
      },
      order_no: "",
      user_name: "",
      tips: "",
      order_id: "",
      xing: "",
      dialogTableVisible: false,
      dialogTableVisible1: false,
      dialogTableVisible2: false,
      jieguo: "",
      tabledata: [],
      user_id: "",
      // 输入框值
      yushou: "",
      // 租期id
      shneheList: [],
      // 租期列表
      zqlist: "",
      /*显示弹框*/
      dialogVisible: false,
      /*切换菜单*/
      activeName: "all",
      /*是否加载完成*/
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      // /*横向表单数据模型*/
      // searchForm: {
      //   search: "",
      //   order_no: "",
      //   style_id: "",
      //   create_time: "",
      //   total_price: "",
      //   price: "",
      // },
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /*时间*/
      create_time: "",
      create_time1: "",
      total_price: "",
      peice: "",

      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0,
        cancel: 0,
        haveInHand: 0,
        buyOut: 0,
        Returning: 0,
        returned: 0,
        examine: 0,
        refuse: 0,
      },
      isLogistics: false,
      logisticsData: {},
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*删除弹窗确定*/
    queding6() {
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let data = {
          order_id: this.order_id,
        }
        OrderApi.deletehetong(data, true)
          .then(res => {
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.dialogTableVisible2 = false;
            this.getData();
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },

    /*删除订单显示*/
    godelete(row) {
      // console.log(row);
      this.dialogTableVisible2 = true;
      this.order_id = row.order_id;
      this.user_name = row.user_name;
      this.order_no = row.order_no;
    },
    shuaixn() {
      this.loading = false;
      this.getData();
    },
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      OrderApi.mayiliandaikou(Params, true)
        .then((data) => {
          self.loading = false;
          self.tabledata = data.data.list.data;
          for (let i = 0; i < self.tabledata.length; i++) {
            let zhuangtai1 = self.tabledata[i];
            //总风险决策结果
            if (zhuangtai1.process_status == 0) {
              zhuangtai1.process_status = "草稿";
            } else if (zhuangtai1.process_status == 1) {
              zhuangtai1.process_status = "签署中";
            } else if (zhuangtai1.process_status == 2) {
              zhuangtai1.process_status = "完成";
            } else if (zhuangtai1.process_status == 3) {
              zhuangtai1.process_status = "撤销";
            } else if (zhuangtai1.process_status == 4) {
              zhuangtai1.process_status = "终止";
            } else if (zhuangtai1.process_status == 5) {
              zhuangtai1.process_status = "过期";
            } else if (zhuangtai1.process_status == 6) {
              zhuangtai1.process_status = "删除";
            } else if (zhuangtai1.process_status == 7) {
              zhuangtai1.process_status = "拒签";
            }
            self.tabledata[i].jieguo = zhuangtai1.process_status;
            self.order_id = self.tabledata[i].order_id;
            self.user_name = self.tabledata[i].user_name;
            self.order_no = self.tabledata[i].order_no;
            // console.log(zhuangtai1.cancel_withholding_time);
            if (zhuangtai1.cancel_withholding_time == "") {
              self.tabledata[i].cancel_withholding_time = 0;
            } else {
              let date1 = new Date(zhuangtai1.cancel_withholding_time * 1000);
              //时间戳为10位需*1000，时间戳为13位的话不需乘1000
              let y1 = date1.getFullYear();
              let MM1 = date1.getMonth() + 1;
              MM1 = MM1 < 10 ? "0" + MM1 : MM1; //月补0
              let d1 = date1.getDate();
              d1 = d1 < 10 ? "0" + d1 : d1; //天补0
              let h1 = date1.getHours();
              h1 = h1 < 10 ? "0" + h1 : h1; //小时补0
              let m1 = date1.getMinutes();
              m1 = m1 < 10 ? "0" + m1 : m1; //分钟补0
              let s1 = date1.getSeconds();
              s1 = s1 < 10 ? "0" + s1 : s1; //秒补0
              var bbbb =
                y1 + "-" + MM1 + "-" + d1 + " " + h1 + ":" + m1 + ":" + s1;
              // console.log("sadasdasdsa", bbbb);
              self.tabledata[i].cancel_withholding_time = bbbb;
            }
          }
          self.totalDataNumber = data.data.list.total;
        })
        .catch((error) => { });
    },
    chaxun(row) {
      this.dialogTableVisible = true;
      // console.log("id", row.flowId);
      let self = this;
      let flowId = row.flowId;
      let Params = { flowId: flowId };
      OrderApi.chaxun(Params, true)
        .then((data) => {
          // console.log("状态", data.data.data.flowDesc);
          self.xing = data.data.data.flowDesc;
        })
        .catch((error) => { });
    },
    xiazai(row) {
      let self = this;
      let flowId = row.flowId;
      let Params = { flowId: flowId };
      OrderApi.xiazai(Params, true)
        .then((data) => {
          // console.log("状态", data);
          // console.log("xiazai", data.data.data.docs);
          let list = data.data.data.docs;
          for (let index = 0; index < list.length; index++) {
            if (list[index].fileName == "演示租蚂蚁链用户授权协议.pdf") {
              // console.log(list[[index]].fileName);
              window.open(list[[index]].fileUrl, "_blank");
            }
          }
        })
        .catch((error) => { });
    },

    xiazai2(row) {
      let self = this;
      let flowId = row.flowId;
      let Params = { flowId: flowId };
      OrderApi.xiazai(Params, true)
        .then((data) => {
          // console.log("状态", data);
          // console.log("xiazai", data.data.data.docs);
          let list = data.data.data.docs;
          for (let index = 0; index < list.length; index++) {
            if (list[index].fileName == "演示租蚂蚁链个人信用信息查询及报送授权书.pdf") {
              // console.log(list[[index]].fileName);
              window.open(list[[index]].fileUrl, "_blank");
            }
          }
        })
        .catch((error) => { });
    },

    xiazai3(row) {
      let self = this;
      let flowId = row.flowId;
      let Params = { flowId: flowId };
      OrderApi.xiazai(Params, true)
        .then((data) => {
          console.log("状态", data);
          console.log("xiazai", data.data.data.docs);
          let list = data.data.data.docs;
          for (let index = 0; index < list.length; index++) {
            if (list[index].fileName != "演示租蚂蚁链用户授权协议.pdf" && list[index].fileName != "演示租蚂蚁链个人信用信息查询及报送授权书.pdf") {
              console.log(list[[index]].fileName);
              window.open(list[[index]].fileUrl, "_blank");
            }
          }
        })
        .catch((error) => { });
    },
    quxiao(row) {
      console.log(row);
      let self = this;
      let tips = "";
      console.log(row, "row");
      self.dialogTableVisible1 = true;
      self.order_id = row.order_id;
      self.order_no = row.order_no;
      self.user_name = row.user_name;
    },
    dialogTableVisible1() {
      this.dialogTableVisible1 = false;
    },
    /*备注弹窗确定*/
    queding5() {
      let Params = {
        order_id: this.order_id,
        tips: this.tips
      };
      OrderApi.daikoujieyue(Params, true).then((data) => {
        // console.log("结果", data);
        this.dialogTableVisible1 = false;
        this.getData();
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      })
        .catch((error) => {
          this.$message({
            message: '操作失败',
            type: 'warning'
          });
        });;
    },
    dakai(user_url) {
      // console.log("user_url", user_url);
      window.open(user_url, "_blank");
    },
    openLogistics() {
      this.isLogistics = true;
    },
    closeLogistics() {
      this.isLogistics = false;
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function () {
      let baseUrl = window.location.protocol + "//" + window.location.host;
      window.location.href =
        baseUrl +
        "/index.php/shop/order.operate/export?" +
        qs.stringify(this.searchForm);
    },
  },
  filters: {
    // 过滤器
    formatDate(create_time1) {
      let date = new Date(create_time1 * 1000);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s; //年月日时分秒
    },
  },
};
</script>
<style lang="scss">
.d1 {
  width: 100px;
  list-style: none;
  border: 1px solid #ffa49f;
  padding: 5px;
  background-color: #fff1f0;
  color: #f6363e;
  border-radius: 10px;
  text-align: center;
  margin: 25px 0;
}

.anniu {
  margin-bottom: 2px;
}

.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}

.qianshu {
  font-size: 20px;
  color: red;
}

.daikou {
  font-size: 30px;
  color: red;
}

.dingdan {
  font-size: 20px;
  color: red;
}

.qing {
  font-size: 20px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/mayilian/mayilian/list.vue